import { HeaderName, OperationContext, OperationHeaders } from "./models"

export function getHeadersFromContext(
  context: OperationContext,
  token?: string,
  customer?: string,
): OperationHeaders {
  const headers: OperationHeaders = {
    [HeaderName.Accept]: "application/json",
  }

  if (context?.rememberMeToken) {
    headers[HeaderName.RememberMe] = context.rememberMeToken
  }

  if (token && !context.shouldUseAuthSchema) {
    headers[HeaderName.Authorization] = `Bearer ${token}`
  }

  if (customer && !context.isUserVisitor) {
    headers[HeaderName.TenantName] = customer
  }

  return headers
}
